<template>
  <svg
    class="rete-flow-connection"
    :class="{ 'rete-flow-connection--preview': data.isPseudo }"
    :data-rete-connection-id="data.isPseudo ? null : data.id"
    data-testid="connection"
  >
    <title v-if="!data.isPseudo">
      Clique para destacar o fluxo · botão direito para apagar
    </title>
    <path
      class="rete-flow-connection__hit"
      :d="path"
      @pointerdown.stop
      @pointerup.stop
    />
    <path class="rete-flow-connection__line" :d="path" />
  </svg>
</template>

<script>
export default {
  props: ["data", "start", "end", "path"]
};
</script>

<style scoped>
.rete-flow-connection {
  height: 9999px;
  overflow: visible !important;
  pointer-events: none;
  position: absolute;
  width: 9999px;
}
.rete-flow-connection path {
  fill: none;
}
.rete-flow-connection__hit {
  cursor: pointer;
  pointer-events: stroke;
  stroke: transparent;
  stroke-width: 18px;
}
.rete-flow-connection__line {
  pointer-events: none;
  stroke: #8d76b1;
  stroke-width: 3px;
  transition: stroke 0.15s;
}
.rete-flow-connection:hover .rete-flow-connection__line {
  stroke: #7047a4;
}
.rete-flow-connection--preview .rete-flow-connection__hit {
  pointer-events: none;
}
</style>
